// extracted by mini-css-extract-plugin
export default {"channel_events_row":"ChannelEventsRow_channel_events_row__gfote"};